import * as React from "react";
import { Button, Popover, Spinner } from "@/components/ui";
import { formatReviewCount } from "./utils";

type ReviewFiltersPopoverLayoutProps = {
  children: React.ReactNode;
  onClear?: () => void;
  onDone: () => void;
  side?: "right" | "bottom";
  sideOffset?: number;
  initialFocus?: boolean;
  resultCount?: number | null;
};

/** Shared chrome for Coach and Player review filter popovers. */
export function ReviewFiltersPopoverLayout({
  children,
  onClear,
  onDone,
  side = "right",
  sideOffset = 8,
  initialFocus,
  resultCount,
}: ReviewFiltersPopoverLayoutProps) {
  return (
    <Popover.Content
      className="w-[380px] max-w-[calc(100vw-2rem)] shadow-xl border border-slate-100 bg-white rounded-xl focus:outline-hidden overflow-hidden"
      align="end"
      side={side}
      sideOffset={sideOffset}
      initialFocus={initialFocus}
    >
      <div className="flex min-w-0 flex-col gap-4 overflow-hidden">
        <div className="grid min-w-0 gap-4 overflow-x-hidden overflow-y-auto p-1 max-h-[600px] no-scrollbar [&>*]:min-w-0">
          {children}
        </div>

        <div className="flex justify-end items-center shrink-0 gap-2">
          {typeof resultCount === "number" ? (
            <span className="text-xs text-muted-foreground mr-auto">{formatReviewCount(resultCount)}</span>
          ) : resultCount === null ? (
            <Spinner className="size-3.5 text-muted-foreground/70 mr-auto" />
          ) : null}
          {onClear ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClear}
              className="text-slate-500 hover:text-slate-800 h-8 text-xs"
            >
              Clear All
            </Button>
          ) : null}
          <Button size="sm" onClick={onDone} className="h-8 text-xs">
            Done
          </Button>
        </div>
      </div>
    </Popover.Content>
  );
}
